import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import PrayerForm from '../Form';
import { createPrayer } from '@resources/Prayer/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createPrayer, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createPrayer(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.prayer.create',
						defaultMessage:
							'A new Prayer has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.prayer',
					defaultMessage: 'Create Prayer',
				})}
			</Title>
			<PrayerForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createPrayer })(Create);
